module.exports = __webpack_public_path__ + "img/service-12.b597adc2.jpg";